import React from "react";
import { Flame, Trophy, Calendar } from "lucide-react";

/**
 * Card streak formativo — mostra giorni consecutivi correnti + record.
 * Props: streak = { corrente, record, ultimo_giorno_attivita, oggi_attivo }
 */
export default function StreakCard({ streak }) {
  if (!streak) return null;
  const { corrente = 0, record = 0, oggi_attivo = false } = streak;
  const attivo = corrente > 0;

  return (
    <div
      className={`rounded-2xl border p-5 md:p-6 relative overflow-hidden ${
        attivo
          ? "border-[#f59e0b]/40 bg-gradient-to-br from-[#fff7ed] via-white to-[#fef3c7]"
          : "border-slate-200 bg-white"
      }`}
      data-testid="streak-card"
    >
      {attivo && (
        <div className="absolute -top-8 -right-8 h-32 w-32 rounded-full bg-[#f59e0b]/20 blur-2xl pointer-events-none" />
      )}
      <div className="relative flex items-center gap-4">
        <div
          className={`h-14 w-14 rounded-2xl flex items-center justify-center shrink-0 ${
            attivo
              ? "bg-gradient-to-br from-[#f59e0b] to-[#d97706] text-white shadow-lg"
              : "bg-slate-100 text-slate-400"
          }`}
        >
          <Flame className={`h-7 w-7 ${attivo ? "" : "opacity-60"}`} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#b45309]">
            Streak Formativa
          </div>
          <div className="mt-0.5 flex items-baseline gap-2 flex-wrap">
            <span
              className={`text-3xl font-extrabold ${
                attivo ? "text-[#0a1f55]" : "text-slate-400"
              }`}
              data-testid="streak-corrente"
            >
              {corrente}
            </span>
            <span className="text-[13px] font-bold text-slate-600">
              {corrente === 1 ? "giorno consecutivo" : "giorni consecutivi"}
            </span>
          </div>
          <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px] text-slate-500">
            <span className="inline-flex items-center gap-1" title="Il tuo record personale">
              <Trophy className="h-3.5 w-3.5 text-[#f59e0b]" />
              Record: <strong className="text-[#0a1f55]">{record}</strong>
            </span>
            {attivo && !oggi_attivo && (
              <span className="inline-flex items-center gap-1 text-amber-700 font-semibold">
                <Calendar className="h-3.5 w-3.5" />
                Studia oggi per non perderla!
              </span>
            )}
            {oggi_attivo && (
              <span className="inline-flex items-center gap-1 text-emerald-700 font-semibold">
                <Calendar className="h-3.5 w-3.5" />
                Attivo oggi
              </span>
            )}
          </div>
        </div>
      </div>
      {!attivo && (
        <p className="relative mt-3 text-[12px] text-slate-500 leading-relaxed">
          Studia oggi per accendere la tua streak: bastano pochi minuti al giorno per costruire l&apos;abitudine e non fermarti più.
        </p>
      )}
    </div>
  );
}
